import { request } from '../request';
import { StaffEditData } from '@libs/models/talents';

export function editTalent(
  id: string,
  data: Omit<StaffEditData, 'status'> & {
    image: File | null;
    isImageUrlNeedToBeUpdated: boolean;
  },
) {
  const dataToSend: StaffEditRequestData = {
    ...data,
    locationId: data.location.id,
    qualificationPayRates: data.qualificationPayRates.map((q) => ({
      id: q.qualification.id,
      rateType: q.rateType,
      rate: q.rate,
      specialtyPayRates: q.specialtyPayRates.map((s) => ({
        id: s.specialty.id,
        rate: s.rate,
      })),
    })),
  };
  const form = new FormData();

  Object.entries(dataToSend).forEach(([key, value]) => {
    if (key === 'image') {
      if (dataToSend.isImageUrlNeedToBeUpdated) {
        if (value) {
          form.append(key, value as File);
        }
      }
      return;
    }
    if (key === 'availableForTravelDistance') {
      form.append(key, (value as string) ?? '0');
      return;
    }
    if (typeof value === 'object' && value !== null) {
      form.append(key, JSON.stringify(value));
      return;
    }

    form.append(key, value?.toString() ?? '');
  });

  return request.patch<string>(`/v2/staff/${id}`, form);
}

type StaffEditRequestData = {
  isImageUrlNeedToBeUpdated: boolean;
  image: File | null;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  address: {
    firstAddress: string;
    city: string;
    state: string;
    zipCode: string;
    secondAddress: string;
  };
  hrInfo: {
    primaryRegion: {
      city: string;
      state: string;
    };
    secondaryRegions: {
      city: string;
      state: string;
    }[];
  };
  jobTitle: string;
  locationId: string;
  qualificationPayRates: {
    id: string; //'nursequalification-00000000000000000000000000';
    rateType: string; //'Hourly';
    rate: number;
    specialtyPayRates: {
      id: string; //'speciality-00000000000000000000000000';
      rate: number;
    }[];
  }[];
  employmentType: string;
  availableForTravelDistance: number;
  workShifts: {
    dayOfWeek: string; // 'Sunday';
    startTime: string; // '00:00:00';
    duration: string; //'00:00:00';
  }[];
  contractType: string;
};
